module.exports = {"email":"email","account_email":"Your account email","password":"Password","repeat_password":"Re-type your password","firstname":"Firstname","lastname":"Lastname","special_ocation":"Is it a special occasion?","comments":"Any other comments you want to give to the restaurant? Please keep in mind that not all requests can be answered (optional)","choose":"Choose","male":"Male","female":"Female","search":" Find a restaurant","password_not_match":"Re-type your password rightly","fill_your_data":"Fill your data"}


//////////////////
// WEBPACK FOOTER
// ./src/app/locale/en/inputs.json
// module id = 722
// module chunks = 18